const cbor = require('cbor-web');

/*
передайте highWaterMarkпараметр со значением наибольшего размера буфера, который, по вашему мнению, вам понадобится:
cbor.encodeOne(new ArrayBuffer(40000), {highWaterMark: 65535})
использовать потоковый режим. Поймать data, finishи errorсобытия. Обязательно позвоните, end() когда закончите.

const enc = new cbor.Encoder()
enc.on('data', buf => /* Send the data somewhere *//* null)
enc.on('error', console.error)
enc.on('finish', () => /* Tell the consumer we are finished *//* null)

enc.end(['foo', 1, false])
use encodeAsync(), который использует подход из подхода 2, чтобы вернуть неэффективное для памяти обещание для буфера.*/


export class CborDataDecorator { 

	/*todo: tpl map,
	 *todo:  buffer sync*/
	 
	constructor () {
		
	}
	
	async encode(data: any, tpl?: string) {
		return cbor.encodeAsync(data, {canonical: true});
	}
	
	async decode(data: any, tpl?: string){
		console.log(data);
		let blob = new Blob([data]);
		console.log(blob);
		if(blob.size>0){
		     let datac = new Uint8Array(await blob.arrayBuffer())
		let d = cbor.decode(datac);
		 return d;}
		else {
			return data;
			}		
	}
}